import React, { useEffect, useState } from 'react'
import { Button, Divider, Drawer } from 'antd'
import { MenuUnfoldOutlined } from '@ant-design/icons'
import './styles.scss'

const items = [
    {
        key: '1',
        label: 'Service Guarantee',
        link: '#service-guarantee',
    },
    {
        key: '2',
        label: 'On-Time Service Guarantee',
        link: '#on-time-guarantee',
    },
    {
        key: '3',
        label: 'Satisfaction Guarantee',
        link: '#satisfaction-guarantee',
    },
    {
        key: '4',
        label: '24/7 Customer Support Guarantee',
        link: '#customer-support-guarantee',
    },
    {
        key: '5',
        label: 'Safety and Quality Guarantee',
        link: '#safety-quality-guarantee',
    },
    {
        key: '6',
        label: 'Claim Process',
        link: '#claim-process',
    },
    {
        key: '7',
        label: 'Exclusions',
        link: '#exclusions',
    }
]

const ServiceGuarantee = () => {
    const [isNavDrawerOpen, setIsNavDraweOpen] = useState(false);

    useEffect(() => {
        const url = window.location.href;
        const section = url.split('#')[1];
        if (section) {
            scrollToSection(`#${section}`);
        }
    }, []);

    const scrollToSection = (id) => {
        const section = document.querySelector(id);
        if (section) {
            const offset = window.innerWidth > 768 ? 100 : 60;
            const sectionPosition = section.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
                top: sectionPosition,
                behavior: 'smooth',
            });
        }
    };

    return (
        <div className='service-guarantee section_main' style={{ marginBottom: '60px' }}>
            <div className='top_padding_container'>
                <h1 className='header_1'>
                    Service Guarantee
                </h1>
                <p>
                    Version 1.0.0 - Last updated: 2024-10-07
                </p>
            </div>

            <div className='mobile_nav'>
                <Button onClick={() => setIsNavDraweOpen(true)}><MenuUnfoldOutlined /> Open Menu</Button>
            </div>

            <div className='body'>
                <div className='terms__nav'>
                    {items.map((item) => (
                        <div
                            key={item.key}
                            className='terms__nav__container__items__item'
                            onClick={() => scrollToSection(item.link)}
                        >
                            {item.label}
                        </div>
                    ))}
                </div>

                <div className='terms'>
                    <h2 className='heder_2' id='service-guarantee'>
                        VisitPearl.com Service Guarantee
                    </h2>
                    <p className='paragraph'>
                        At VisitPearl.com, we are committed to providing exceptional service and ensuring that our customers have a seamless and memorable experience. To demonstrate our confidence in the quality of our services, we proudly offer the following service guarantees.
                    </p>

                    <Divider />

                    <h2 className='heder_2 sec' id='on-time-guarantee'>
                        1. On-Time Service Guarantee
                    </h2>
                    <p className='paragraph'>
                        We understand how important your time is, and we are dedicated to ensuring that your tour operates as scheduled.
                    </p>
                    <h3 className='header_4'>
                        Guarantee:
                    </h3>
                    <p className='paragraph'>
                        We guarantee that all tours and activities will be running per schedule within the itinerary.
                    </p>
                    <h3 className='header_4'>
                        Remedy:
                    </h3>
                    <p className='paragraph'>
                        If any part of your tour cannot be accommodated at the time, whether it is an activity, experience or stay due to unforeseen circumstances, we will replace the item with an equivalent.
                    </p>

                    <Divider />

                    <h2 className='heder_2 sec' id='satisfaction-guarantee'>
                        2. Satisfaction Guarantee
                    </h2>
                    <p className='paragraph'>
                        Your satisfaction is our top priority. We strive to deliver the best experiences and meet your expectations every step of the way.
                    </p>
                    <h3 className='header_4'>
                        Guarantee:
                    </h3>
                    <p className='paragraph'>
                        If you are not completely satisfied with any part of your experience, please inform us as soon as possible, and we will work to resolve the issue.
                    </p>
                    <h3 className='header_4'>
                        Remedy:
                    </h3>
                    <p className='paragraph'>
                        In case of dissatisfaction, we will compensate you accordingly. This maybe in the form of refunds, discounts, alternative tour items or others. Please contact us to organise further details.
                    </p>

                    <Divider />

                    <h2 className='heder_2 sec' id='customer-support-guarantee'>
                        3. 24/7 Customer Support Guarantee
                    </h2>
                    <p className='paragraph'>
                        We are here for you whenever you need assistance during your tour.
                    </p>
                    <h3 className='header_4'>
                        Guarantee:
                    </h3>
                    <p className='paragraph'>
                        Our dedicated support team is available 24/7 during your tour to assist you with issues or emergencies.
                    </p>
                    <ul>
                        <li>We offer the services of tour guides, who are the first point of contact</li>
                        <li>We recommend that you purchase travel insurance, this can be through our partner covermore or any external insurance provider.</li>
                        <li>We will provide specific contacts locally who can assist you in instances of issues or emergencies.</li>
                    </ul>

                    <Divider />

                    <h2 className='heder_2 sec' id='safety-quality-guarantee'>
                        4. Safety and Quality Guarantee
                    </h2>
                    <p className='paragraph'>
                        We place the utmost importance on the safety and quality of our tours.
                    </p>
                    <h3 className='header_4'>
                        Guarantee:
                    </h3>
                    <p className='paragraph'>
                        All of our tours and activities are designed with your safety in mind, and we guarantee that all services will meet the highest safety standards and quality expectations. We highly recommend that you choose one of our tour guides
                    </p>
                    <ul>
                        <li>We have a curated list of tour guides who you can make a part of your tour.</li>
                        <li>This will greatly enhance your experience during your travels. Our tour guides are individuals that are vetted and qualified by the SLTDA(Sri Lanka Tourist Board.)</li>
                    </ul>

                    <Divider />

                    <h2 className='heder_2 sec' id='claim-process'>
                        Claim Process
                    </h2>
                    <p className='paragraph'>
                        We aim to make the claim process as simple and hassle-free as possible. If you wish to claim under one of our service guarantees:
                    </p>
                    <ul>
                        <li>Contact our customer service team via email per contact details in our website as soon as possible.</li>
                        <li>Provide a brief description of the issue and any relevant details (e.g., photos, timestamps).</li>
                        <li>Our team will review your claim within 2 business days and follow up with you for resolution.</li>
                    </ul>

                    <Divider />

                    <h2 className='heder_2 sec' id='exclusions'>
                        Exclusions
                    </h2>
                    <p className='paragraph'>
                        Please note that these guarantees do not apply in situations where delays, disruptions, or dissatisfaction are caused by:
                    </p>
                    <ul>
                        <li>Events outside our control, such as natural disasters, political unrest, or flight cancellations.</li>
                        <li>Customer-related issues, such as incorrect booking details or failure to arrive on time.</li>
                        <li>Third-party providers not directly contracted by VisitPearl.com.</li>
                    </ul>
                    <p className='paragraph'>
                        Please see our terms and conditions for further details.
                    </p>
                    <p className='paragraph'>
                        We value your trust in VisitPearl.com and are committed to ensuring you have an outstanding experience with us. Our service guarantees are our promise to you that we will always do our best to meet and exceed your expectation
                    </p>
                </div>
            </div>

            <Drawer
                title="Basic Drawer"
                className='home__nav__drawer'
                rootClassName='home__nav__drawer_body'
                placement='bottom'
                closable={false}
                open={isNavDrawerOpen}
                onClose={() => setIsNavDraweOpen(false)}
                height='70vh'
                headerStyle={{ display: 'none' }}
            >
                <div className='terms__nav_drawe'>
                    {items.map((item) => (
                        <div
                            key={item.key}
                            className='terms__nav__container__items__item_drawer'
                            onClick={() => {
                                scrollToSection(item.link)
                                setIsNavDraweOpen(false)
                            }}
                        >
                            {item.label}
                        </div>
                    ))}
                </div>
            </Drawer>
        </div>
    )
}

export default ServiceGuarantee